import Core from '@/core/module';

export default class ContentHide extends Core {
    init() {
        this.addEventListeners();
    }

    addEventListeners() {
    	const _this = this;

        $(window).on('resize.contentHide', (e) => {
        	this.$el.each(function(){
        		if($(this).find('.content__inner')[0].scrollHeight > $(this).height()) {
        			$(this).addClass('content--notall-active');
        		}
        	});
        }).trigger('resize.contentHide');

        this.$el.on('click', '.content__button', (e) => {
        	e.preventDefault();

        	const $el = $(e.currentTarget);

        	$el.closest('.content').addClass('content--open');
        });
    }
}